import React from 'react';
import { Link } from 'react-router-dom';

/**
 * BubbleX wordmark + optional "the living social exchange" tagline.
 * Use everywhere we render the brand so the positioning is consistent.
 *
 * Props:
 *  - to: optional Link path (omit for non-clickable)
 *  - size: 'sm' | 'md' | 'lg'   (default md)
 *  - tagline: bool              (default true)
 *  - testid
 */
const SIZES = {
  sm: { dot: 'h-7 w-7', word: 'text-lg', tag: 'text-[8px] tracking-[0.32em]' },
  md: { dot: 'h-8 w-8', word: 'text-xl', tag: 'text-[9px] tracking-[0.36em]' },
  lg: { dot: 'h-11 w-11', word: 'text-3xl sm:text-4xl', tag: 'text-[10px] sm:text-[11px] tracking-[0.4em]' },
};

const Inner = ({ size, tagline }) => {
  const s = SIZES[size] || SIZES.md;
  return (
    <span className="flex items-center gap-2.5">
      <span className={`${s.dot} rounded-full bg-gradient-to-br from-bx-cyan via-bx-magenta to-bx-volt breathe shrink-0`} />
      <span className="flex flex-col leading-none">
        <span className={`font-display font-black tracking-tight ${s.word}`}>BubbleX</span>
        {tagline && (
          <span className={`uppercase text-white/45 mt-1 ${s.tag}`}>
            the living social exchange
          </span>
        )}
      </span>
    </span>
  );
};

const BubbleLogo = ({ to, size = 'md', tagline = true, testid }) => {
  if (to) {
    return (
      <Link to={to} data-testid={testid} className="inline-flex items-center">
        <Inner size={size} tagline={tagline} />
      </Link>
    );
  }
  return (
    <span data-testid={testid} className="inline-flex items-center">
      <Inner size={size} tagline={tagline} />
    </span>
  );
};

export default BubbleLogo;
